/**
 * 管理后台文案（韩、中、英）。
 *
 * 背景：PRD 7 章管理后台：账号查询、余额调整、退款、模型与价格、上游渠道、账号策略、审计日志、配置版本。
 * 设计意图：按页面分组；运营同事以中文、韩文为主，英文保持完整以便外包或审计方查看。
 * 关键约束：只被管理后台引用，控制台打包结果里没有这些文案。
 */
export const A = {
  nav: {
    title: { ko: '관리자 콘솔', zh: '管理後台', en: 'Admin' },
    dashboard: { ko: '대시보드', zh: '總覽', en: 'Dashboard' },
    payments: { ko: '결제', zh: '訂單與商品', en: 'Payments' },
    audit: { ko: '감사 기록', zh: '審計日誌', en: 'Audit log' },
    businessCockpit: { ko: '경영 대시보드', zh: '經營駕駛艙', en: 'Business cockpit' },
    overview: { ko: '대시보드', zh: '儀錶盤', en: 'Dashboard' },
    analytics: { ko: '결제 분석', zh: '付費分析', en: 'Payer analytics' },
    costAnalytics: { ko: '원가 산정', zh: '成本測算', en: 'Cost analytics' },
    costControls: { ko: '원가 관리', zh: '成本管控', en: 'Cost controls' },
    modelUsage: { ko: '사용량 통계', zh: '用量統計', en: 'Model usage' },
    accounts: { ko: '사용자와 과금', zh: '使用者與計費', en: 'Users & billing' },
    orders: { ko: '충전 주문', zh: '儲值訂單', en: 'Recharge orders' },
    campaign: { ko: '충전 이벤트', zh: '儲值活動', en: 'Recharge campaign' },
    campaignStats: { ko: '이벤트 통계', zh: '活動統計', en: 'Campaign stats' },
    firstRechargeStats: { ko: '충전 전환', zh: '儲值轉化', en: 'Recharge funnel' },
    usageReward: { ko: '선물과 혜택', zh: '贈禮與福利', en: 'Rewards & gifts' },
    giftRedemption: { ko: '선물 지급', zh: '贈送兌付', en: 'Gift redemption' },
    codes: { ko: '활성화 코드', zh: '啟用碼', en: 'Activation codes' },
    providers: { ko: '공급사 설정', zh: '供應商配置', en: 'Providers' },
    providerModels: { ko: '채널 모델 라이브러리', zh: '渠道模型庫', en: 'Channel model library' },
    models: { ko: '게시된 모델', zh: '已發布模型', en: 'Published models' },
    autoRouting: { ko: 'AI 자동 모델 선택', zh: 'AI 自動選模', en: 'Auto routing' },
    capabilities: { ko: '범용 기능', zh: '通用能力', en: 'Capabilities' },
    queue: { ko: '추론 대기열', zh: '推理隊列', en: 'Inference queue' },
    logs: { ko: '요청 로그', zh: '請求日誌', en: 'Request logs' },
    images: { ko: '이미지 기록', zh: '生圖記錄', en: 'Image records' },
    videos: { ko: '영상 기록', zh: '影片記錄', en: 'Video records' },
    audios: { ko: '오디오 기록', zh: '音頻記錄', en: 'Audio records' },
    searchRecords: { ko: '검색 기록', zh: '搜尋記錄', en: 'Search records' },
    abuse: { ko: '어뷰징 방지', zh: '反濫用', en: 'Abuse control' },
    tickets: { ko: '세션 티켓', zh: '會話票據', en: 'Session tickets' },
    fallback: { ko: '폴백과 알림', zh: '降級與告警', en: 'Fallback & alerts' },
    configAudit: { ko: '설정 변경', zh: '配置變更', en: 'Config audit' },
    groupBiz: { ko: '경영 분석', zh: '經營分析', en: 'Business' },
    groupUsers: { ko: '사용자와 수익', zh: '使用者與收入', en: 'Users & revenue' },
    groupCatalog: { ko: '모델과 공급사', zh: '模型與供應商', en: 'Models & providers' },
    groupOps: { ko: '운영과 보안', zh: '運行與安全', en: 'Operations & security' },
  },
  login: {
    title: { ko: '관리자 로그인', zh: '管理後台登入', en: 'Admin login' },
    lead: { ko: '운영 계정으로 로그인해요. 2단계 인증을 켠 계정은 인증 코드도 입력해요', zh: '使用運營帳號登入；已開啟兩步驗證的帳號還需填寫動態碼', en: 'Log in with an operator account. Accounts with two-factor on also enter a code' },
    submit: { ko: '로그인', zh: '登入', en: 'Log in' },
    codeHint: { ko: '2단계 인증을 켠 계정만 입력해요. 인증 앱의 6자리 숫자', zh: '僅已開啟兩步驗證的帳號填寫，驗證器 App 裡的 6 位數字', en: 'Only for accounts with two-factor on. The 6-digit code in your authenticator app' },
  },
  role: {
    support: { ko: '지원', zh: '客服', en: 'Support' },
    admin: { ko: '관리자', zh: '管理員', en: 'Admin' },
    readOnly: { ko: '지원 역할은 조회와 Key 폐기, 계정 잠금만 할 수 있어요', zh: '客服角色只能查看、吊銷 Key 與鎖定帳號', en: 'Support can view, revoke keys and lock accounts only' },
  },
  status: {
    active: { ko: '정상', zh: '正常', en: 'Active' },
    locked: { ko: '잠김', zh: '已鎖定', en: 'Locked' },
    deleted: { ko: '탈퇴', zh: '已登出', en: 'Deleted' },
    suspended: { ko: '정지', zh: '已停用', en: 'Suspended' },
    enabled: { ko: '사용', zh: '啟用', en: 'Enabled' },
    disabled: { ko: '꺼짐', zh: '停用', en: 'Disabled' },
  } as Record<string, { ko: string; zh: string; en: string }>,
  dash: {
    title: { ko: '대시보드', zh: '總覽', en: 'Dashboard' },
    lead: { ko: '전체 사용 금액, 상위 비용, 마진과 데이터 플레인 설정 상태예요', zh: '全站消費、上遊成本、毛利與資料面配置狀態', en: 'Site-wide revenue, upstream cost, margin and data-plane config' },
    revenue: { ko: '사용 금액', zh: '消費金額', en: 'Revenue' },
    upstream: { ko: '상위 비용', zh: '上遊成本', en: 'Upstream cost' },
    margin: { ko: '마진', zh: '毛利', en: 'Margin' },
    caveatUnknown: { ko: '상위 비용을 알 수 없는 요청 {u}건은 마진에서 뺐어요', zh: '上遊成本未知的請求 {u} 次不計入毛利', en: '{u} requests with unknown upstream cost are excluded from margin' },
    caveatMetered: { ko: '기록만 하는 요청 {m}건(정가 합계 {v})은 매출에 넣지 않았어요', zh: '僅記帳的請求 {m} 次（刊例價合計 {v}）不計入消費金額', en: '{m} metered-only requests (list value {v}) are not counted as revenue' },
    marginRate: { ko: '마진율 {p}%', zh: '毛利率 {p}%', en: '{p}% margin' },
    requests: { ko: '요청 {n}건 · 실패 {f}건', zh: '請求 {n} 次 · 失敗 {f} 次', en: '{n} requests · {f} failed' },
    daily: { ko: '일별 사용 금액 (UTC, USD)', zh: '每日消費（UTC，美元）', en: 'Daily revenue (UTC, USD)' },
    byModel: { ko: '모델별', zh: '按模型', en: 'By model' },
    byChannel: { ko: '채널별', zh: '按渠道', en: 'By channel' },
    byOrg: { ko: '계정별', zh: '按帳號', en: 'By account' },
    config: { ko: '설정 버전', zh: '配置版本', en: 'Config version' },
    instances: { ko: '데이터 플레인 인스턴스', zh: '資料面實例', en: 'Data-plane instances' },
    instance: { ko: '인스턴스', zh: '實例', en: 'Instance' },
    version: { ko: '버전', zh: '版本', en: 'Version' },
    seen: { ko: '{n}초 전', zh: '{n} 秒前', en: '{n}s ago' },
    seenMin: { ko: '{n}분 전', zh: '{n} 分鐘前', en: '{n} min ago' },
    seenHour: { ko: '{n}시간 전', zh: '{n} 小時前', en: '{n} h ago' },
    showStale: { ko: '응답 없는 인스턴스 보기 ({n}개)', zh: '顯示失聯實例（{n} 個）', en: 'Show stale instances ({n})' },
    alive: { ko: '응답 중', zh: '在線', en: 'Alive' },
    stale: { ko: '응답 없음', zh: '失聯', en: 'Stale' },
    upToDate: { ko: '최신', zh: '已同步', en: 'Up to date' },
    behind: { ko: '이전 버전', zh: '版本落後', en: 'Behind' },
    noInstances: { ko: '최근 하루 동안 보고한 인스턴스가 없어요', zh: '最近一天沒有實例上報', en: 'No instance reported in the last day' },
    recent: { ko: '최근 변경', zh: '最近變更', en: 'Recent changes' },
  },
  accounts: {
    title: { ko: '계정', zh: '帳號', en: 'Accounts' },
    lead: { ko: '이메일 앞부분이나 계정 ID로 찾아요', zh: '按電子信箱前綴或帳號 ID 查找', en: 'Search by email prefix or account ID' },
    search: { ko: '이메일 또는 ID', zh: '電子信箱或 ID', en: 'Email or ID' },
    operator: { ko: '운영 역할', zh: '運營角色', en: 'Operator role' },
    emailVerified: { ko: '이메일 인증', zh: '電子信箱驗證', en: 'Email verification' },
    verified: { ko: '인증됨', zh: '已驗證', en: 'Verified' },
    unverified: { ko: '미인증', zh: '未驗證', en: 'Unverified' },
    kind: { ko: '종류', zh: '類型', en: 'Kind' },
    kindAll: { ko: '모든 종류', zh: '全部類型', en: 'All kinds' },
    kindUser: { ko: '일반 사용자', zh: '使用者', en: 'User' },
    kindService: { ko: '서비스 계정', zh: '服務帳號', en: 'Service account' },
    serviceHint: { ko: '서비스 계정은 로그인 입구가 없고 운영자가 이 화면에서 관리해요', zh: '服務帳號沒有登入入口，由運營在這裡管理', en: 'Service accounts have no login; operators manage them here' },
    sessions: { ko: '활성 세션', zh: '有效會話', en: 'Active sessions' },
    totp: { ko: '2단계 인증', zh: '兩步驗證', en: 'Two-factor' },
    lock: { ko: '잠그기', zh: '鎖定', en: 'Lock' },
    unlock: { ko: '잠금 해제', zh: '解鎖', en: 'Unlock' },
    lockTitle: { ko: '{email} 계정을 잠글까요?', zh: '鎖定 {email}？', en: 'Lock {email}?' },
    unlockTitle: { ko: '{email} 계정의 잠금을 풀까요?', zh: '解鎖 {email}？', en: 'Unlock {email}?' },
    lockBody: { ko: '잠그면 이 계정의 모든 로그인 세션이 바로 끊겨요. API Key는 영향을 받지 않아요. 호출까지 막으려면 계정 정책에서 상태를 정지로 바꿔 주세요', zh: '鎖定後該帳號所有登入會話立即失效；API Key 不受影響，要停止呼叫請在帳號策略裡把狀態改為停用', en: 'Locking signs out every session. API keys are not affected; to stop calls, set the status to suspended in the account policy' },
    setRole: { ko: '운영 역할 바꾸기', zh: '修改運營角色', en: 'Change operator role' },
    roleNone: { ko: '없음 (일반 사용자)', zh: '無（普通使用者）', en: 'None (regular user)' },
    roleBody: { ko: '바꾸면 그 계정의 관리자 세션이 모두 끊겨요. 2단계 인증을 켠 계정만 운영 역할을 받을 수 있어요', zh: '修改後該帳號的管理後台會話全部失效；只有開啟兩步驗證的帳號才能獲得運營角色', en: 'This signs out their admin sessions. Only accounts with two-factor on can hold an operator role' },
    deleteRequested: { ko: '탈퇴 신청: {date}', zh: '申請登出：{date}', en: 'Deletion requested: {date}' },
    changed: { ko: '변경했어요', zh: '已修改', en: 'Updated' },
  },
  detail: {
    priceMultiplier: { ko: '가격 배율', zh: '價格倍率', en: 'Price multiplier' },
    priceMultiplierHint: { ko: '1은 정가 그대로, 0.8은 20% 할인이에요. 0이면 요금을 받지 않고 사용량만 기록해요 (Yeou 같은 내부 서비스용)', zh: '1 為原價，0.8 為八折；0 表示不扣費、只記帳（給 Yeou 這類內部服務用）', en: '1 is list price, 0.8 is 20% off. 0 records usage without charging (for internal services such as Yeou)' },
    discountCode: { ko: '할인 코드', zh: '優惠碼', en: 'Discount code' },
    discountCodeHint: { ko: '정산 내역에 남기는 표시용 문자열이에요', zh: '只寫進結算明細，用於對帳歸因', en: 'Recorded on each settlement for attribution' },
    billing: { ko: '과금', zh: '計費', en: 'Billing' },
    metered: { ko: '기록만', zh: '僅記帳', en: 'Metered only' },
    editPricing: { ko: '가격 설정', zh: '價格設定', en: 'Pricing' },
    pricingSaved: { ko: '가격 설정을 저장했어요', zh: '價格設定已保存', en: 'Pricing saved' },
    kind: { ko: '종류', zh: '類型', en: 'Kind' },
    tabOverview: { ko: '개요', zh: '概況', en: 'Overview' },
    tabKeys: { ko: 'API Key', zh: 'API Key', en: 'API keys' },
    tabLedger: { ko: '꽃잎 내역', zh: '花瓣流水', en: 'Ledger' },
    tabUsage: { ko: '요청 내역', zh: '請求明細', en: 'Requests' },
    tabOrders: { ko: '주문', zh: '訂單', en: 'Orders' },
    tabAudit: { ko: '감사 기록', zh: '審計', en: 'Audit' },
    paid: { ko: '유료 잔액', zh: '有償餘額', en: 'Paid balance' },
    bonus: { ko: '보너스 잔액', zh: '贈送餘額', en: 'Bonus balance' },
    available: { ko: '사용 가능', zh: '可用', en: 'Available' },
    held: { ko: '진행 중 요청 동결 {n}', zh: '進行中凍結 {n}', en: '{n} held in flight' },
    unsettled: { ko: '미정산 {n}', zh: '未結算 {n}', en: '{n} unsettled' },
    activeKeys: { ko: '사용 중인 Key', zh: '可用 Key', en: 'Active keys' },
    policy: { ko: '계정 정책', zh: '帳號策略', en: 'Account policy' },
    editPolicy: { ko: '정책 수정', zh: '修改策略', en: 'Edit policy' },
    rpm: { ko: '분당 요청 수', zh: '每分鐘請求數', en: 'Requests per minute' },
    concurrent: { ko: '동시 요청 수', zh: '並行數', en: 'Concurrent requests' },
    daily: { ko: '하루 사용 한도 (꽃잎)', zh: '每日花費上限（花瓣）', en: 'Daily spend limit (petals)' },
    retainFixed: { ko: '요청과 응답 본문 보관', zh: '對話正文保存', en: 'Body retention' },
    retainFixedValue: { ko: '모든 계정 공통, {n}일 (컴플라이언스 보관)', zh: '全部帳號統一保存 {n} 天（合規備查，沒有帳號級開關）', en: '{n} days for every account (compliance retention, no per-account switch)' },
    systemKey: { ko: '시스템 Key', zh: '系統 Key', en: 'System key' },
    systemKeyApp: { ko: '앱 {id}', zh: '應用 {id}', en: 'App {id}' },
    systemKeyHint: { ko: '로그인할 때 자동으로 만들어지는 Key예요. 폐기할 수 없고 이름과 한도만 바꿀 수 있어요', zh: '登入時自動建立的 Key，不能吊銷，只能改名與限額', en: 'Created automatically at sign-in. It cannot be revoked; only its name and quota can change' },
    wallet: { ko: '지갑', zh: '錢包', en: 'Wallet' },
    vendorExport: { ko: '상위 업체 데이터 제공 허용', zh: '允許向上遊提供資料', en: 'Allow vendor data export' },
    emptyMeansNone: { ko: '비워 두면 제한 없음', zh: '留空不限', en: 'Empty means none' },
    adjust: { ko: '잔액 조정', zh: '餘額調整', en: 'Adjust balance' },
    grantBonus: { ko: '보너스 지급', zh: '贈送花瓣', en: 'Grant bonus' },
    adjustHint: { ko: '양수는 보상, 음수는 차감이에요. 유료 잔액에 반영돼요 (한 번에 최대 1,000만 꽃잎)', zh: '正數補償、負數扣減，記入有償餘額（單次最多 1,000 萬花瓣）', en: 'Positive compensates, negative deducts. Applies to paid balance (max 10M petals)' },
    bonusHint: { ko: '보너스 꽃잎은 유료 잔액보다 먼저 써요', zh: '贈送花瓣先於有償餘額消費', en: 'Bonus petals are spent before paid balance' },
    amountPetals: { ko: '금액 (꽃잎)', zh: '金額（花瓣）', en: 'Amount (petals)' },
    memo: { ko: '메모 (사용자 내역에도 보여요)', zh: '備註（使用者流水裡可見）', en: 'Memo (visible to the user)' },
    posted: { ko: '반영했어요', zh: '已入帳', en: 'Posted' },
    duplicate: { ko: '같은 요청이 이미 반영돼 있어요', zh: '同一請求已入帳，沒有重複記帳', en: 'Already posted; not applied twice' },
    createKey: { ko: '서비스 Key 만들기', zh: '新建服務 Key', en: 'Create service key' },
    purpose: { ko: '용도', zh: '用途', en: 'Purpose' },
    purposeHint: { ko: '소문자, 숫자, - 만 (예: yeoui-chat)', zh: '小寫字母、數字、-（例如 yeoui-chat）', en: 'Lowercase, digits, - (e.g. yeoui-chat)' },
    priority: { ko: '최대 우선순위', zh: '最高優先級', en: 'Max priority' },
    showRevoked: { ko: '폐기된 Key도 보기', zh: '顯示已吊銷', en: 'Show revoked' },
    keyActive: { ko: '사용 중', zh: '可用', en: 'Active' },
    keyExpired: { ko: '만료됨', zh: '已過期', en: 'Expired' },
    keyRevoked: { ko: '폐기됨', zh: '已吊銷', en: 'Revoked' },
    revoke: { ko: '폐기', zh: '吊銷', en: 'Revoke' },
    revokeTitle: { ko: '{name} Key를 폐기할까요?', zh: '吊銷 Key「{name}」？', en: 'Revoke key {name}?' },
    revokeBody: { ko: '이 Key를 쓰는 호출이 바로 거부돼요. 되돌릴 수 없어요', zh: '使用這個 Key 的呼叫會立即被拒絕，無法撤銷', en: 'Calls using this key are rejected immediately. This cannot be undone' },
    quota: { ko: '사용 한도 (꽃잎)', zh: '額度（花瓣）', en: 'Quota (petals)' },
    used: { ko: '사용량', zh: '已用', en: 'Used' },
    lastUsed: { ko: '마지막 사용', zh: '最近使用', en: 'Last used' },
    models: { ko: '허용 모델 (쉼표로 구분)', zh: '允許的模型（逗號分隔）', en: 'Allowed models (comma separated)' },
    createdOnce: { ko: '이 Key는 지금 한 번만 보여요. 서비스의 비밀 저장소에 바로 넣어 주세요', zh: '這個 Key 只顯示這一次，請立即放進服務的密鑰存儲', en: 'Shown only once. Put it into the service secret store now' },
    negative: { ko: '잔액이 음수({n} 꽃잎)라서 유료 호출이 멈춰 있어요', zh: '餘額為負（{n} 花瓣），付費呼叫已暫停', en: 'Balance is negative ({n} petals); paid calls are paused' },
    upstream: { ko: '상위 모델 / 채널', zh: '上遊模型 / 渠道', en: 'Upstream / channel' },
  },
  models: {
    title: { ko: '모델과 가격', zh: '模型與價格', en: 'Models & pricing' },
    lead: { ko: '판매가는 선택한 통화 기준이에요. 저장하면 새 설정 버전이 모든 데이터 플레인에 배포돼요', zh: '售價按所選幣種填寫；保存後生成新配置版本並下發到所有資料面', en: 'Prices use the selected currency. Saving publishes a new config version to every data plane' },
    create: { ko: '새 모델', zh: '新建模型', en: 'New model' },
    id: { ko: '모델 ID', zh: '模型 ID', en: 'Model ID' },
    idHint: { ko: '사용자가 호출할 때 쓰는 이름. 만든 뒤 바꿀 수 없어요', zh: '使用者呼叫時用的名字，建立後不能改', en: 'The name callers use. Cannot change later' },
    kind: { ko: '종류', zh: '類型', en: 'Kind' },
    kindLocked: { ko: '종류는 바꿀 수 없어요', zh: '類型不能修改', en: 'Kind cannot change' },
    displayName: { ko: '표시 이름', zh: '顯示名稱', en: 'Display name' },
    description: { ko: '설명', zh: '說明', en: 'Description' },
    sellPrice: { ko: '판매가', zh: '售價', en: 'Price' },
    inPrice: { ko: '입력 (USD/100만 토큰)', zh: '輸入（美元/百萬 Token）', en: 'Input (USD / 1M tokens)' },
    cachedPrice: { ko: '캐시 입력 (USD/100만 토큰)', zh: '快取輸入（美元/百萬 Token）', en: 'Cached input (USD / 1M tokens)' },
    outPrice: { ko: '출력 (USD/100만 토큰)', zh: '輸出（美元/百萬 Token）', en: 'Output (USD / 1M tokens)' },
    imagePrice: { ko: '이미지 1장 (USD)', zh: '每張圖片（美元）', en: 'Per image (USD)' },
    maxTokens: { ko: '기본 max_tokens', zh: '預設 max_tokens', en: 'Default max_tokens' },
    maxChars: { ko: '최대 입력 글자 수', zh: '最大輸入字元數', en: 'Max input characters' },
    enabled: { ko: '사용', zh: '啟用', en: 'Enabled' },
    public: { ko: '가격표에 공개', zh: '在價格表公開', en: 'Listed publicly' },
    sort: { ko: '정렬 순서', zh: '排序', en: 'Sort order' },
    routes: { ko: '라우트', zh: '路由', en: 'Routes' },
    editRoutes: { ko: '라우트 편집', zh: '編輯路由', en: 'Edit routes' },
    routesLead: { ko: '우선순위 숫자가 작은 그룹부터 쓰고, 같은 그룹에서는 24시간 친화도, 가중치 순으로 골라요. 실패하면 체인의 다음 노드로 넘어가요. 원가는 채널 모델 라이브러리에서 관리해요', zh: '優先級數字小的分組先用；同組內先看 24 小時親和，再按權重選；失敗就換鏈上下一個節點。成本在「渠道模型庫」裡維護', en: 'Lower priority groups go first; inside a group the 24 h affinity channel is tried first, then weighted pick. A failure moves to the next node. Costs live in the channel model library' },
    channel: { ko: '채널', zh: '渠道', en: 'Channel' },
    upstreamModel: { ko: '상위 모델명', zh: '上遊模型名', en: 'Upstream model' },
    priority: { ko: '우선순위', zh: '優先級', en: 'Priority' },
    weight: { ko: '가중치', zh: '權重', en: 'Weight' },
    costIn: { ko: '원가 입력', zh: '成本輸入', en: 'Cost in' },
    costCached: { ko: '원가 캐시', zh: '成本快取', en: 'Cost cached' },
    costOut: { ko: '원가 출력', zh: '成本輸出', en: 'Cost out' },
    costImage: { ko: '원가 이미지', zh: '成本圖片', en: 'Cost image' },
    addRoute: { ko: '라우트 추가', zh: '添加路由', en: 'Add route' },
    removeRoute: { ko: '삭제', zh: '刪除', en: 'Remove' },
    noRoutes: { ko: '라우트가 없어서 호출할 수 없어요', zh: '沒有路由，呼叫會失敗', en: 'No routes; calls will fail' },
    currency: { ko: '통화', zh: '幣種', en: 'Currency' },
    promptPrice: { ko: '입력 (100만 토큰)', zh: '輸入（每百萬 Token）', en: 'Input (per 1M tokens)' },
    completionPrice: { ko: '출력 (100만 토큰)', zh: '輸出（每百萬 Token）', en: 'Output (per 1M tokens)' },
    cacheReadPrice: { ko: '캐시 읽기 (100만 토큰)', zh: '快取讀取（每百萬 Token）', en: 'Cache read (per 1M tokens)' },
    cacheWritePrice: { ko: '캐시 쓰기 (100만 토큰)', zh: '快取寫入（每百萬 Token）', en: 'Cache write (per 1M tokens)' },
    perImage: { ko: '이미지 1장', zh: '每張圖片', en: 'Per image' },
    imageMode: { ko: '이미지 과금 방식', zh: '圖片計費方式', en: 'Image billing' },
    imageModePerImage: { ko: '장당', zh: '按張', en: 'Per image' },
    imageModeToken: { ko: '토큰', zh: '按 Token', en: 'By tokens' },
    thinking: { ko: '생각 모드 정책', zh: '思考策略', en: 'Thinking policy' },
    thinkingHint: { ko: '고객이 보낸 enable_thinking을 어떻게 다룰지 정해요. 채팅 모델에만 적용돼요', zh: '決定如何處理呼叫方傳來的 enable_thinking，只對聊天模型有效', en: 'How to treat the caller\'s enable_thinking; chat models only' },
    thinkInherit: { ko: '그대로 전달', zh: '沿用請求', en: 'Inherit' },
    thinkOn: { ko: '항상 켜기', zh: '強制開啟', en: 'Force on' },
    thinkOff: { ko: '항상 끄기', zh: '強制關閉', en: 'Force off' },
    advanced: { ko: '고급 가격 설정 (JSON)', zh: '高級價格配置（JSON）', en: 'Advanced pricing (JSON)' },
    advancedHint: { ko: '비워 두면 사용하지 않아요. 구간가와 시간대가는 함께 쓸 수 없어요', zh: '留空表示不啟用；階梯價與分時價不能同時配置', en: 'Leave empty to disable. Tiers and peak pricing cannot be combined' },
    tiers: { ko: '구간가 (입력 토큰 수 기준)', zh: '階梯價（按輸入 Token 數）', en: 'Pricing tiers (by input tokens)' },
    peak: { ko: '시간대가 (피크)', zh: '分時價（高峰）', en: 'Peak pricing' },
    promo: { ko: '기간 한정가', zh: '限時價', en: 'Promotional pricing' },
    imageTokenPrices: { ko: '이미지 토큰 가격', zh: '圖片 Token 價目', en: 'Image token prices' },
    videoPricing: { ko: '영상 가격', zh: '影片價目', en: 'Video pricing' },
    badJson: { ko: '{name}이(가) 올바른 JSON이 아니에요', zh: '{name} 不是合法的 JSON', en: '{name} is not valid JSON' },
    overrides: { ko: '노드 요청 파라미터 (JSON)', zh: '節點請求參數（JSON）', en: 'Node request parameters (JSON)' },
    overridesHint: { ko: '이 노드로 보낼 때만 요청에 덮어써요. 허용 키: temperature, top_p, reasoning_effort, enable_thinking 등', zh: '只在走這個節點時疊加到請求上，優先級最高；允許的鍵：temperature、top_p、reasoning_effort、enable_thinking 等', en: 'Applied only on this node and wins over the caller. Allowed: temperature, top_p, reasoning_effort, enable_thinking, ...' },
    unregistered: { ko: '채널 모델 라이브러리에 없는 모델이에요. 먼저 등록해 주세요', zh: '渠道模型庫裡沒有這個上遊模型，請先登記', en: 'Not in the channel model library; register it first' },
    savedVersion: { ko: '저장했어요 (설정 버전 {v})', zh: '已保存（配置版本 {v}）', en: 'Saved (config version {v})' },
    noChannels: { ko: '먼저 상위 채널을 만들어 주세요', zh: '請先新建上遊渠道', en: 'Create an upstream channel first' },
  },
  channels: {
    title: { ko: '상위 채널', zh: '上遊渠道', en: 'Upstream channels' },
    lead: { ko: '상위 서비스의 프로토콜, 주소, Key와 상태를 관리해요. Key는 암호화해서 저장하고 끝 4자리만 보여요', zh: '管理上遊服務的協議、地址、Key 與健康狀態；Key 加密存儲，只顯示末 4 位', en: 'Manage upstream protocol, address, key and health. Keys are encrypted; only the last 4 characters are shown' },
    create: { ko: '새 채널', zh: '新建渠道', en: 'New channel' },
    id: { ko: '채널 ID', zh: '渠道 ID', en: 'Channel ID' },
    idHint: { ko: '소문자, 숫자, -, _ 로 2–63자. 만든 뒤 바꿀 수 없어요', zh: '小寫字母、數字、-、_，2–63 位，建立後不能改', en: 'Lowercase, digits, - and _, 2–63 chars. Cannot change later' },
    name: { ko: '이름', zh: '名稱', en: 'Name' },
    baseUrl: { ko: 'Base URL', zh: 'Base URL', en: 'Base URL' },
    apiKey: { ko: '상위 API Key', zh: '上遊 API Key', en: 'Upstream API key' },
    apiKeyKeep: { ko: '비워 두면 기존 Key({hint})를 그대로 써요', zh: '留空則沿用原 Key（{hint}）', en: 'Leave empty to keep the current key ({hint})' },
    rpm: { ko: '분당 요청 수', zh: '每分鐘請求數', en: 'Requests per minute' },
    concurrent: { ko: '동시 요청 수', zh: '並行數', en: 'Concurrent requests' },
    dropParams: { ko: '보내지 않을 파라미터', zh: '不轉發的參數', en: 'Parameters to drop' },
    dropParamsHint: { ko: '쉼표로 구분 (예: reasoning_effort)', zh: '逗號分隔（例如 reasoning_effort）', en: 'Comma separated (e.g. reasoning_effort)' },
    dropCacheKey: { ko: 'prompt_cache_key 빼고 보내기', zh: '去掉 prompt_cache_key', en: 'Drop prompt_cache_key' },
    streamUsage: { ko: '스트림에서 사용량 요청 (stream_options.include_usage)', zh: '流式請求帶 include_usage', en: 'Request usage in streams (include_usage)' },
    http2: { ko: 'HTTP/2 사용', zh: '使用 HTTP/2', en: 'Use HTTP/2' },
    probe: { ko: '연결 확인', zh: '探活', en: 'Probe' },
    probeHint: { ko: 'GET /models만 호출해서 비용이 들지 않아요', zh: '只呼叫 GET /models，不產生費用', en: 'Calls GET /models only; no cost' },
    probeOk: { ko: '정상 · {ms}ms · 모델 {n}개', zh: '正常 · {ms}ms · {n} 個模型', en: 'OK · {ms}ms · {n} models' },
    probeFail: { ko: '실패 · {err} · {ms}ms', zh: '失敗 · {err} · {ms}ms', en: 'Failed · {err} · {ms}ms' },
    protocol: { ko: '프로토콜', zh: '協議', en: 'Protocol' },
    health: { ko: '상태', zh: '健康', en: 'Health' },
    healthy: { ko: '정상', zh: '健康', en: 'Healthy' },
    autoDisabled: { ko: '자동 중지', zh: '自動停用', en: 'Auto-disabled' },
    failures: { ko: '연속 실패 {n}회', zh: '連續失敗 {n} 次', en: '{n} consecutive failures' },
    until: { ko: '{t}까지', zh: '至 {t}', en: 'until {t}' },
    resetHealth: { ko: '수동 복구', zh: '手動恢復', en: 'Recover now' },
    resetHealthHint: { ko: '상위가 복구된 것을 확인했다면 냉각 시간을 기다리지 않고 바로 되살려요', zh: '確認上遊已恢復時，不必等冷卻結束，立即恢復', en: 'Bring it back without waiting for the cooldown' },
    recovered: { ko: '복구했어요 (설정 버전 {v})', zh: '已恢復（配置版本 {v}）', en: 'Recovered (config version {v})' },
    autoDisable: { ko: '연속 실패 시 자동으로 중지', zh: '連續失敗自動停用', en: 'Auto-disable on repeated failures' },
    threshold: { ko: '실패 임계값', zh: '失敗閾值', en: 'Failure threshold' },
    cooldown: { ko: '냉각 시간 (초)', zh: '冷卻時間（秒）', en: 'Cooldown (seconds)' },
    maxCompletionTokens: { ko: 'max_tokens를 max_completion_tokens로 보내기', zh: '把 max_tokens 改成 max_completion_tokens', en: 'Send max_completion_tokens instead of max_tokens' },
    injectReasoning: { ko: '도구 호출 메시지에 reasoning_content 채우기', zh: '為工具呼叫消息補 reasoning_content', en: 'Inject reasoning_content on tool-call messages' },
    retryStatuses: { ko: '같은 채널에서 다시 시도할 상태 코드', zh: '同渠道重試的狀態碼', en: 'Statuses retried on the same channel' },
    retryStatusesHint: { ko: '쉼표로 구분 (예: 408, 429, 504). 502와 503은 항상 다시 시도해요', zh: '逗號分隔（例如 408, 429, 504）；502、503 始終重試', en: 'Comma separated (e.g. 408, 429, 504). 502 and 503 always retry' },
  },
  cm: {
    title: { ko: '채널 모델 라이브러리', zh: '渠道模型庫', en: 'Channel model library' },
    lead: { ko: '채널마다 쓸 수 있는 상위 모델과 공급사 견적을 등록해요. 라우트는 여기 등록된 모델만 쓸 수 있고, 상위 원가도 여기서 계산해요. 견적이 없으면 원가는 알 수 없음으로 기록돼요', zh: '登記每個渠道上的上遊模型和廠商報價。路由只能引用這裡登記過的模型，上遊成本也按這裡計算；沒有報價時成本記為未知', en: 'Register the upstream models of each channel and the vendor quotes. Routes can only use registered models and upstream cost is computed from them; without a quote the cost is recorded as unknown' },
    add: { ko: '모델 등록', zh: '登記模型', en: 'Register model' },
    channel: { ko: '채널', zh: '渠道', en: 'Channel' },
    upstreamModel: { ko: '상위 모델명', zh: '上遊模型名', en: 'Upstream model' },
    quote: { ko: '견적 (정가)', zh: '報價（刊例價）', en: 'Quote (list price)' },
    noQuote: { ko: '견적 없음 (원가 알 수 없음)', zh: '無報價（成本未知）', en: 'No quote (cost unknown)' },
    discount: { ko: '공급사 할인율', zh: '廠商折扣率', en: 'Vendor discount rate' },
    discountHint: { ko: '매입가 = 정가 × 할인율. 0이면 원가 0으로 확정해요. 비우면 정가 그대로예요', zh: '採購價 = 刊例價 × 折扣率；0 表示成本確定為 0；留空表示按刊例價', en: 'Cost = list price x rate. 0 means a known zero cost; empty means list price' },
    listPrompt: { ko: '정가 입력 (100만 토큰)', zh: '刊例價輸入（每百萬 Token）', en: 'List input (per 1M)' },
    listCompletion: { ko: '정가 출력 (100만 토큰)', zh: '刊例價輸出（每百萬 Token）', en: 'List output (per 1M)' },
    listCacheRead: { ko: '정가 캐시 읽기', zh: '刊例價快取讀取', en: 'List cache read' },
    listCacheWrite: { ko: '정가 캐시 쓰기', zh: '刊例價快取寫入', en: 'List cache write' },
    listPerImage: { ko: '정가 이미지 1장', zh: '刊例價每張圖片', en: 'List per image' },
    note: { ko: '메모', zh: '備註', en: 'Note' },
    context: { ko: '컨텍스트 길이', zh: '上下文長度', en: 'Context length' },
    inUse: { ko: '라우트에서 사용 중이라 지울 수 없어요', zh: '正被路由使用，不能刪除', en: 'In use by routes; cannot delete' },
    deleted: { ko: '삭제했어요 (설정 버전 {v})', zh: '已刪除（配置版本 {v}）', en: 'Deleted (config version {v})' },
    confirmDelete: { ko: '{name}을(를) 라이브러리에서 지울까요?', zh: '從模型庫刪除 {name}？', en: 'Delete {name} from the library?' },
  },
  fb: {
    title: { ko: '폴백과 알림', zh: '降級與告警', en: 'Fallback & alerts' },
    lead: { ko: '모델별 폴백 횟수와 전체 실패, 채널 자동 중지와 복구 알림이에요', zh: '各模型的降級切換與全鏈失敗次數，以及渠道自動停用、恢復等告警', en: 'Per-model fallback switches and total failures, plus channel auto-disable and recovery alerts' },
    stats: { ko: '모델별 통계', zh: '按模型統計', en: 'By model' },
    window: { ko: '최근 {n}분', zh: '最近 {n} 分鐘', en: 'Last {n} min' },
    events: { ko: '폴백 이벤트', zh: '降級事件', en: 'Fallback events' },
    alerts: { ko: '알림', zh: '告警', en: 'Alerts' },
    model: { ko: '모델', zh: '模型', en: 'Model' },
    requests: { ko: '요청', zh: '請求', en: 'Requests' },
    switches: { ko: '전환', zh: '切換', en: 'Switches' },
    allFailed: { ko: '전체 실패', zh: '全鏈失敗', en: 'All failed' },
    rate: { ko: '실패율', zh: '失敗率', en: 'Failure rate' },
    kind: { ko: '종류', zh: '類型', en: 'Kind' },
    kindSwitch: { ko: '전환', zh: '切換', en: 'Switch' },
    kindAllFailed: { ko: '전체 실패', zh: '全鏈失敗', en: 'All failed' },
    from: { ko: '기본 채널', zh: '首選渠道', en: 'Primary' },
    to: { ko: '전환된 채널', zh: '切換到', en: 'Switched to' },
    error: { ko: '오류', zh: '錯誤', en: 'Error' },
    time: { ko: '시각', zh: '時間', en: 'Time' },
    noAlerts: { ko: '알림이 없어요', zh: '沒有告警', en: 'No alerts' },
    severity: { ko: '심각도', zh: '級別', en: 'Severity' },
    allKinds: { ko: '모든 종류', zh: '全部類型', en: 'All kinds' },
  },
  pay: {
    title: { ko: '결제', zh: '訂單與商品', en: 'Payments' },
    lead: { ko: '주문 조회, 환불, 결제사 동기화와 대사 결과예요', zh: '訂單查詢、退款、與支付通道同步、對帳結果', en: 'Orders, refunds, provider sync and reconciliation' },
    orders: { ko: '주문', zh: '訂單', en: 'Orders' },
    products: { ko: '상품', zh: '商品', en: 'Products' },
    reconcile: { ko: '대사', zh: '對帳', en: 'Reconciliation' },
    allStatus: { ko: '모든 상태', zh: '全部狀態', en: 'All statuses' },
    accountFilter: { ko: '계정 ID', zh: '帳號 ID', en: 'Account ID' },
    order: { ko: '주문', zh: '訂單', en: 'Order' },
    account: { ko: '계정', zh: '帳號', en: 'Account' },
    amount: { ko: '금액', zh: '金額', en: 'Amount' },
    petals: { ko: '꽃잎', zh: '花瓣', en: 'Petals' },
    paidAt: { ko: '결제 시각', zh: '支付時間', en: 'Paid at' },
    sku: { ko: 'SKU', zh: 'SKU', en: 'SKU' },
    skuHint: { ko: '소문자, 숫자, -, _ (만든 뒤 바꿀 수 없어요)', zh: '小寫字母、數字、-、_（建立後不能改）', en: 'Lowercase, digits, - and _ (cannot change later)' },
    name: { ko: '상품명', zh: '商品名', en: 'Name' },
    price: { ko: '가격 (USD)', zh: '價格（美元）', en: 'Price (USD)' },
    credit: { ko: '충전 꽃잎', zh: '儲值花瓣', en: 'Credited petals' },
    bonus: { ko: '보너스 꽃잎', zh: '贈送花瓣', en: 'Bonus petals' },
    active: { ko: '판매 중', zh: '在售', en: 'On sale' },
    sort: { ko: '정렬 순서', zh: '排序', en: 'Sort order' },
    createProduct: { ko: '새 상품', zh: '新建商品', en: 'New product' },
    events: { ko: '상태 변경', zh: '狀態變化', en: 'Status changes' },
    refunds: { ko: '환불', zh: '退款', en: 'Refunds' },
    refund: { ko: '환불', zh: '退款', en: 'Refund' },
    refundTitle: { ko: '주문을 환불할까요?', zh: '為這筆訂單退款？', en: 'Refund this order?' },
    refundAmount: { ko: '환불 금액 (USD)', zh: '退款金額（美元）', en: 'Refund amount (USD)' },
    refundHint: { ko: '최대 {max}. 환불 비율만큼 꽃잎을 회수해서 잔액이 음수가 될 수 있어요', zh: '最多 {max}；按退款比例扣回花瓣，餘額可能變負', en: 'Up to {max}. Petals are clawed back pro rata; the balance may go negative' },
    refunded: { ko: '환불을 요청했어요', zh: '退款已提交', en: 'Refund submitted' },
    sync: { ko: '결제사와 동기화', zh: '與支付通道同步', en: 'Sync with provider' },
    synced: { ko: '동기화했어요', zh: '已同步', en: 'Synced' },
    channelIds: { ko: '결제사 ID', zh: '通道單號', en: 'Provider IDs' },
    attempts: { ko: '충전 시도', zh: '入帳嘗試', en: 'Fulfill attempts' },
    lastError: { ko: '마지막 오류', zh: '最近錯誤', en: 'Last error' },
    stuck: { ko: '처리 대기', zh: '待處理', en: 'Needs attention' },
    unfulfilled: { ko: '결제됐지만 충전 전', zh: '已支付未入帳', en: 'Paid, not credited' },
    gaveUp: { ko: '재시도 중단', zh: '已放棄重試', en: 'Gave up retrying' },
    mismatched: { ko: '금액 불일치', zh: '金額不一致', en: 'Amount mismatch' },
    reports: { ko: '일별 대사 보고서', zh: '每日對帳報告', en: 'Daily reports' },
    day: { ko: '날짜', zh: '日期', en: 'Day' },
    ok: { ko: '일치', zh: '一致', en: 'Match' },
    mismatch: { ko: '불일치', zh: '不一致', en: 'Mismatch' },
    noReports: { ko: '아직 대사 보고서가 없어요', zh: '還沒有對帳報告', en: 'No reports yet' },
    from: { ko: '이전', zh: '原狀態', en: 'From' },
    to: { ko: '이후', zh: '新狀態', en: 'To' },
  },
  audit: {
    title: { ko: '감사 기록', zh: '審計日誌', en: 'Audit log' },
    lead: { ko: '서비스마다 자기 DB에 감사 기록을 따로 남겨요', zh: '每個服務把審計寫在各自的庫裡', en: 'Each service keeps its own audit log' },
    identity: { ko: '계정 서비스', zh: '帳號服務', en: 'Identity' },
    control: { ko: '게이트웨이', zh: 'Gateway', en: 'Gateway' },
    billing: { ko: '결제', zh: '支付', en: 'Billing' },
    actor: { ko: '수행자', zh: '操作者', en: 'Actor' },
    action: { ko: '작업', zh: '動作', en: 'Action' },
    target: { ko: '대상', zh: '對象', en: 'Target' },
    detail: { ko: '상세', zh: '詳情', en: 'Detail' },
    targetFilter: { ko: '대상 ID로 거르기', zh: '按對象 ID 過濾', en: 'Filter by target ID' },
  },
} satisfies Record<string, unknown>
